import { render, staticRenderFns } from "./Pension.vue?vue&type=template&id=0da2a32c&"
import script from "./Pension.vue?vue&type=script&lang=js&"
export * from "./Pension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports